import { render, staticRenderFns } from "./LocationNumberTable.vue?vue&type=template&id=5d99b283&"
import script from "./LocationNumberTable.vue?vue&type=script&lang=ts&"
export * from "./LocationNumberTable.vue?vue&type=script&lang=ts&"
import style0 from "./LocationNumberTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VRow})
